module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headerLine', {
    ref: "dialog",
    attrs: {
      "showbar": "true",
      "index": "9"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('technology.name')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title"
  }, [_vm._v("\n            THE HIGHWAY TO ULTRA HD\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text2'))
    }
  }, [_vm._v("\n            挑战高清极限：4K，6K，8K\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "content_item_text content_item_text1",
    staticStyle: {
      "width": "90%",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "justify"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text3'))
    }
  }, [_vm._v("\n            威尔直播自研VR高清直播／点播编解码算法，\n          ")]), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "width": "6.85rem",
      "height": "3.2rem",
      "margin-right": "auto",
      "margin-left": "auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[9]),
      expression: "imglist[9]"
    }],
    staticStyle: {
      "width": "6.85rem",
      "height": "3.2rem",
      "margin-right": "auto",
      "margin-left": "auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "compareWords clearfix",
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text30'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "center",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text31'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "compareWords",
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }, [_c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-bottom": "0.7rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text32'))
    }
  })])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "content_item clearfix",
    staticStyle: {
      "background": "#f3faff",
      "padding-bottom": "0.7rem"
    }
  }, [_c('div', {
    staticClass: "fr",
    staticStyle: {
      "margin-right": "0.5rem"
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[3]),
      expression: "imglist[3]"
    }],
    staticStyle: {
      "width": "3.3rem",
      "height": "2.31rem",
      "margin-top": "0.1rem"
    },
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fr content_item_title2",
    staticStyle: {
      "margin-top": "0.8rem",
      "text-align": "left"
    }
  }, [_c('h3', {
    staticClass: "content_item_title content_item_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text4'))
    }
  }, [_vm._v("\n                    上行带宽节省70%\n                  ")]), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title ",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text5'))
    }
  }, [_vm._v("\n                    开启全民VR直播时代\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content_item clearfix",
    staticStyle: {
      "padding-bottom": "0.7rem",
      "padding-top": "0.5rem"
    }
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    staticStyle: {
      "width": "3.4rem",
      "height": "2.2rem",
      "margin-top": "0.3rem"
    },
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fl content_item_title3",
    staticStyle: {
      "margin-top": "0.9rem",
      "margin-left": "0.5rem",
      "text-align": "left"
    }
  }, [_c('h3', {
    staticClass: "content_item_title content_item_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text8'))
    }
  }, [_vm._v("\n                    下行带宽节省70%\n                  ")]), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text9'))
    }
  }, [_vm._v("\n                    4K高清不在话下\n                  ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "background": "#f3faff"
    }
  }, [_c('div', {
    staticClass: "content_item_title content_item_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text23'))
    }
  }, [_vm._v("\n            专利音频编解码\n          ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[7]),
      expression: "imglist[7]"
    }],
    staticStyle: {
      "width": "5.68rem",
      "height": "2.91rem",
      "margin": "0.4rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content_item item_bg4"
  }, [_c('div', {
    staticClass: "content_item_title content_item_title1 white",
    staticStyle: {
      "margin-top": "2.64rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text25'))
    }
  }, [_vm._v("\n              下载体验Demo App\n            ")]), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('div', {
    staticClass: "content_item_text ",
    staticStyle: {
      "color": "#fff",
      "margin": "0.3rem 0",
      "font-size": "0.22rem",
      "margin-bottom": "0"
    }
  }, [_vm._v("\n              Experience our quality 4K streaming in sporting"), _c('br'), _vm._v("\n              events, concerts, and eSports through our demo. \n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "margin-bottom": "0.3rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/download"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text27'))
    }
  }, [_vm._v("下载Demo")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('router-link', {
    staticClass: "button_default",
    attrs: {
      "to": "/solution"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('technology.text28'))
    }
  }, [_vm._v("应用场景")])], 1)])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-119fdb94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/technology.vue
// module id = 86
// module chunks = 0